<template>
    <div class="content">
        <div class="container doc-container" v-if="$i18n.locale === 'zh'">
          <h3>为您的应用程序设置app-ads.txt</h3>
          <p><a href="javascript:void(0)">App-ads.txt</a>是应用程序开发人员上传到其开发人员网站的文本文件，其中列出了授权销售该开发人员库存的广告来源。就像在网络上一样，IAB创建了一个系统，允许买家知道谁有权买卖特定的应用内广告库存，谁没有。这是消除某些类型的欺诈行为、提高整体系统透明度和效率的重要一步。大多数精明的品牌营销人员和需求方平台不会购买没有实现ads.txt的库存。</p>
          <h3>App-ads.txt实现</h3>
          <p>以下是如何确保您的库存包含在appads.txt中：
              <br><br>
              步骤1.创建app-ads.txt文件
              <br>
              如果您还没有，请使用IAB技术实验室提供的规范创建app-ads.txt文件
              <br><br>
              步骤2.将以下代码片段复制并粘贴到app-ads.txt文件中
              <br><br>
              <div class="text-area-container">
                <el-input v-model="result" class="result" ref="result" rows="22" type="textarea" disabled v-loading="listLoading"/>
                <el-button @click="onCopy" type="primary">复制</el-button>
            </div>
              步骤3.发布app-ads.txt文件
              <br>
              在开发者网站的根目录上发布app-ads.txt（例如，<a href="javascript:void(0)">sampledomain.com/app-ads.txt</a>）。 
              <br>
              确保输入的域（例如，<a href="javascript:void(0)">sampledomain.com</a>）与Google Play或App Store上列出的完全一致。
              <br><br>
              步骤4.上传
              <br>
              上传您域名网站根目录下的文件（例如，<a href="javascript:void(0)">www.example.com/app-ads.txt</a>）</p>
        </div>
        <div class="container doc-container" v-else>
          <h3>Set up app-ads.txt for your apps</h3>
          <p><a href="javascript:void(0)">App-ads.txt</a> is a text file app developers upload to their developer website, which lists the ad sources authorized to sell that developer's inventory. Just like on web,the IAB created a system which allows buyers to know who is authorized to buy and sell specific in-app ad inventory, and who isn't.This is animportant step towards eliminating certain types of fraud, and improving the transparency and efficiency of the overall eccosystem. Most savvy brand marketers and demand side plaforms won't buy inventory that doesn't have ads.txt implemented.</p>
          <h3>App-ads.txt implementation</h3>
          <p>Here's how you can make sure your inventory is covered by appads.txt:
              <br><br>
              Step 1. Create an app-ads.txt file
              <br>
              If you haven't already, create an app-ads.txt file using the spec provided by IAB Tech Lab
              <br><br>
              Step 2. Copy and paste the following code snippet into yourapp-ads.txt file
              <br><br>
              <div class="text-area-container">
                <el-input v-model="result" class="result" ref="result" rows="22" type="textarea" disabled v-loading="listLoading"/>
                <el-button @click="onCopy" type="primary">{{ $t('copy.copy') }}</el-button>
            </div>
              Step 3. Publish an app-ads.txt file
              <br>
              Publish your app-ads.txt on the root of your developer website (for example, <a href="javascript:void(0)">sampledomain.com/app-ads.txt</a>). 
              <br>
              Make sure that the domain(for example, <a href="javascript:void(0)">sampledomain.com</a>) is entered exactly as listed on Google Play or the App Store.
              <br><br>
             Step 4. Upload
              <br>
              Upload the file in the root of your domain website (example: <a href="javascript:void(0)">www.example.com/app-ads.txt</a>)</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            result: '',
            exchange_id: '',
            listLoading: false
        }
    },
    computed:{
    },
    created() {
        this.getappadsTxt()
    },
    methods: {
        onCopy() {
          if(this.result) {
              this.$copyText(this.result).then(() => {
              this.$message.success({ message: this.$t('copy.copySuccess') })
              }).catch(() => {
              this.$message.error({ message: this.$t('copy.copyError') })
              })
          }else {
            this.$message.error({ message: this.$t('copy.copyTips') })
          }
        },
        async getappadsTxt() {
          this.listLoading = true
            await this.__postData('sspAppList', {page: 1, page_size: 20},res => {
               this.exchange_id = res.list[0].exchange_id
            })
            let params = {
                exchange_id: this.exchange_id
                // exchange_id: 5035
            }
            await this.__getData('getTxt', params, (res) => {
                this.listLoading = false
                this.result = res.text  
             })
        }
    }
}
</script>
<style scoped> 
h3 {
    margin: 15px 0;
    font-size: 20px;
}
a {
    color: #356DF4;
}
p {
    font-size: 15px;
}
.text-area-container {
  max-width: 1150px;
  width: 100%;
  /* margin: auto; */
  text-align:right;
  /* border: 1px solid #262626; */
}

.result >>> textarea {
  font-size: 15px;
  margin-bottom: 10px;
  color: rgb(40, 43, 47) !important;
  cursor: default !important;
}
</style>
